export enum BookmarkSectionType {
    MOVIES = 'vod_asset_bookmarks',
    VOD_SERIES = 'vod_series_bookmarks',
    BROADCASTS_AND_SERIES = 'program_series_bookmarks',
    PROGRAMS = 'program_bookmarks',
    LISTINGS = 'listing_bookmarks',
    CHANNELS = 'channel_bookmarks',
    PERSONS = 'person_bookmarks',
}

export type BookmarksResponse = Partial<Record<BookmarkSectionType, Record<string, boolean>>>;

export type BookmarkCategory = {
    titleCount: number;
    childCategories?: BookmarkCategory[];
};

export type BookmarkItem = {
    name: BookmarkSectionType;
    bookmarks: { [id: string]: boolean };
};
